import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Tab, TabList } from '@tremor/react';
import { MdCheckCircle } from 'react-icons/md';
import { Title, NewScreen } from '_atoms';
import IncidentList from '../support-desk/incident-reports/IncidentList';
import IncidentForm from '../support-desk/incident-reports/IncidentForm';
import IncidentDetail from '../support-desk/incident-reports/IncidentDetail';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedIncident, setSelectedIncident } from '_redux/slices/incidents/incidents';

const IncidentReports = () => {
    const dispatch = useDispatch();
    const [tab, setTab] = useState(1);
    const [showSuccess, setShowSuccess] = useState(false);
    const selectedIncident = useSelector(selectSelectedIncident);

    const handleIncidentSelect = (incident) => {
        dispatch(setSelectedIncident(incident));
        setTab(1);
    };

    const handleFormSuccess = () => {
        setShowSuccess(true);
    };

    const handleSuccessConfirm = () => {
        setShowSuccess(false);
        setTab(1);
    };

    return (
        <NewScreen>
            <Row>
                <Col>
                    <Title subtitle="Incident Reports" description="Create and manage incident reports and track employee acknowledgements" />
                </Col>
            </Row>

            <Row>
                <TabList
                    value={tab}
                    onValueChange={(value) => {
                        setTab(value);
                        setShowSuccess(false);
                        if (value === 1) dispatch(setSelectedIncident(null));
                    }}
                    marginTop="mt-6"
                >
                    <Tab value={1} text="Incident Reports" />
                    <Tab value={2} text="Report Form" />
                </TabList>
            </Row>

            {tab === 1 && !selectedIncident && (
                <IncidentList
                    onSelect={handleIncidentSelect}
                    onAddReport={() => setTab(2)}
                />
            )}

            {tab === 1 && selectedIncident && (
                <IncidentDetail
                    incidentId={selectedIncident.id}
                    onBack={() => dispatch(setSelectedIncident(null))}
                />
            )}

            {tab === 2 && !showSuccess && (
                <IncidentForm
                    onSuccess={handleFormSuccess}
                    onCancel={() => setTab(1)}
                />
            )}

            {tab === 2 && showSuccess && (
                <Row className="mt-4">
                    <Col xs={12}>
                        <div style={{
                            width: '100%',
                            background: '#D1E7DD',
                            border: '1px solid #A3CFBB',
                            borderLeft: '6px solid #198754',
                            borderRadius: 8,
                            padding: '24px 28px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 18,
                            flexWrap: 'wrap',
                        }}>
                            <div style={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                boxShadow: '0 2px 6px rgba(21, 87, 36, 0.15)',
                            }}>
                                <MdCheckCircle size={40} color="#198754" />
                            </div>
                            <div style={{ flex: 1, minWidth: 240 }}>
                                <p style={{ margin: 0, fontWeight: 700, fontSize: 17, color: '#155724' }}>
                                    Incident Report Created
                                </p>
                                <p style={{ margin: '4px 0 0', color: '#155724', fontSize: 14 }}>
                                    The incident report has been successfully created and assigned employees have been notified.
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={handleSuccessConfirm}
                                style={{
                                    padding: '10px 28px',
                                    border: 'none',
                                    borderRadius: 8,
                                    background: '#198754',
                                    color: '#fff',
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    flexShrink: 0,
                                }}
                            >
                                Done
                            </button>
                        </div>
                    </Col>
                </Row>
            )}
        </NewScreen>
    );
};

export default IncidentReports;
